import { useMemo } from 'react';

import { DataTableInstance } from '@/components-new/data-table/use-data-table';

/**
 * Retrieves and memoizes the rows of a data table instance based on its state and options.
 * Filters out grouped rows when virtualization is enabled to prevent empty spaces.
 */
export const useDataTableRows = <TData>(table: DataTableInstance<TData>) => {
  const {
    getRowModel,
    getState,
    options: { data, enableRowVirtualization, showAggregateGroupRow }
  } = table;

  const {
    globalFilter,
    pagination,
    sorting,
  } = getState();

  return useMemo(() => {
    const allRows = getRowModel().rows;
    
    // If row virtualization is enabled and we're not showing aggregate group rows,
    // filter out the grouped header rows to prevent empty spaces in virtualization
    if (enableRowVirtualization && !showAggregateGroupRow) {
      return allRows.filter(row => !row.getIsGrouped());
    }
    
    return allRows;
  }, [
    data,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    getRowModel().rows,
    enableRowVirtualization,
    showAggregateGroupRow
  ]);
};
